export const getCurrentDateString = () => {
    const date = new Date();
    const pad = (n) => String(n).padStart(2, "0");

    const y = date.getFullYear();
    const m = pad(date.getMonth() + 1);
    const d = pad(date.getDate());
    return  `${y}-${m}-${d}`;
}

